import $ from 'jquery';

export default {
  triggerClass: '.js-cafe-select-trigger',
  sectionClass: '.cat-cafe-select',
  panelClass: '.cat-cafe-select__cell',
  panelIsSelectedFlag: 'cat-cafe-select__cell--selected',
  containsSelectedFlag: 'cat-cafe-select--contains-selected',
  selectedClass: null,
  containsSelectedClass: null,
  formWrapperSelector: '#gform_wrapper_29',
  formSelector: null,
  fieldSelector: '.js-cafe-select-field input',
  firstTime: true,

  _bindEvents() {

    $(this.triggerClass).click( e => {
      this.select(e.target);
    });

    $(`${this.flagClass} ${this.triggerClass}`).click( e => {
      this.unselect();
    });

    $(this.formSelector).change( () => {
      this.setButtonState(this.formIsKindaValid());
    });
  },

  init() {
    this.selectedClass = `.${this.panelIsSelectedFlag}`;
    this.containsSelectedClass = `.${this.containsSelectedFlag}`;
    this.formSelector = `${this.formWrapperSelector} form`;
    this.setButtonState(false);
    this._bindEvents();
    this.prePopulate();
    if (this.formHasError()) this.scrollToForm();
  },

  select(trigger) {
    this.clearFlags();
    $(trigger).parent(this.panelClass).addClass(this.panelIsSelectedFlag);
    $(this.sectionClass).addClass(this.containsSelectedFlag);
    this.updateFormField( $(trigger).data('value') );
    this.triggerChange();
    if ( this.firstTime ) {
      this.scrollToForm();
      this.firstTime = false;
    }
  },

  unselect() {
    this.clearFlags();
    this.updateFormField('');
    this.triggerChange();
  },

  clearFlags() {
    $(this.selectedClass).removeClass(this.panelIsSelectedFlag);
    $(this.sectionClass).removeClass(this.containsSelectedFlag);
  },

  updateFormField(value) {
    $(this.fieldSelector).removeAttr('checked');
    if (value) {
      $(this.fieldSelector).val([value]);
    }
  },

  prePopulate() {
    const selected = $(`${this.fieldSelector}:checked`).val();
    const activeTrigger = $(`${this.triggerClass}[data-value="${selected}"]`)[0];

    if ( activeTrigger ) {
      this.select(activeTrigger);
    }
  },

  formHasError() {
    return $(`${this.formWrapperSelector} .validation_error`).length;
  },

  scrollToForm() {
    $('html, body').animate({
      scrollTop: $(this.formSelector).offset().top - 100
    }, 300);
  },

  formIsKindaValid() {
    // lame validation for a lame feature
    // should not be used for any critical validation

    const $checked = $(`${this.fieldSelector}:checked`);
    if ( $checked.length ) return true;
    return false;
  },

  setButtonState(active) {
    //$(`${this.formSelector} input[type="submit"]`).toggleClass('disabled', !active);
    $(`${this.formSelector} input[type="submit"]`).attr('disabled', !active);
  },

  triggerChange() {
    $(this.formSelector).trigger('change');
  },
}
